import { axiosInstance } from "@/services/axiosInstance";

export const TransactionResource = {
  getStatusHistory: parametros => {
    return axiosInstance.get("v1/transaction/:transactionhash/history", {
      urlParams: parametros
    });
  },

  getById: parametros => {
    return axiosInstance.get("v1/transaction/:transactionhash/transaction", {
      urlParams: parametros
    });
  },

  getListUnsync: parametros => {
    return axiosInstance.get("v1/transaction/unsync", {
      params: parametros
    });
  },

  requeueTransaction: parametros => {
    axiosInstance.defaults.timeout = 500000;
    return axiosInstance.post("v1/transaction/requeue", parametros);
  },

  getSummaryBySeller: parametros => {
    return axiosInstance.get("v1/transaction/summarybyseller", {
      params: parametros
    });
  },

  getTopCustomerByComissioner: parametros => {
    return axiosInstance.get("v1/transaction/gettopcustomerbycommissioner", {
      params: parametros
    })
  },

  getMonthSummaryBySeller: parametros => {
    return axiosInstance.get("v1/transaction/monthsummarybyseller", {
      params: parametros
    });
  },

  getBillingForecast: parametros => {
    return axiosInstance.get("v1/transaction/billingForecast", {
      params: parametros
    });
  },

  getMerchantDashboard: parametros => {
    return axiosInstance.get("v1/transaction/merchantDashboard", {
      params: parametros
    });
  },

  getTransactionDashboard: parametros => {
    return axiosInstance.get("v1/transaction", {
      params: parametros
    });
  },
  getTransactionTotalsDashboard: parametros => {
    return axiosInstance.get("v1/transaction/totals", {
      params: parametros
    });
  },
  getTransactionMerchantTotalsDashboard: parametros => {
    return axiosInstance.get("v1/transaction/totalsmerchant", {
      params: parametros
    });
  },

};
